import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["src"];
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import { Overlay } from 'foundations-components/transitional/components/Overlay';
import styled from 'styled-components';
import { DownloadIcon } from 'foundations-assets/icons/components/DownloadIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OverlayContainer = styled.div.withConfig({
  displayName: "LightboxImage__OverlayContainer"
})(["position:relative;overflow:hidden;"]);
const LightboxImage = _ref => {
  let {
      src
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    justifyContent: "center",
    blockSize: "100%",
    overflow: "hidden",
    children: /*#__PURE__*/_jsxs(OverlayContainer, {
      children: [src && /*#__PURE__*/_jsx(Image, Object.assign({}, rest, {
        maxBlockSize: "80vh",
        maxInlineSize: "100%",
        role: "img",
        src: src
      })), /*#__PURE__*/_jsx(Overlay, {
        width: "250px",
        paddingBlock: "0",
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "end",
          blockSize: "100%",
          paddingBlockEnd: "600",
          paddingInline: "600",
          children: /*#__PURE__*/_jsx("a", {
            download: true,
            href: src,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/_jsxs(Button, {
              size: "sm",
              use: "secondary",
              children: [/*#__PURE__*/_jsx(DownloadIcon, {}), "Download"]
            })
          })
        })
      })]
    })
  });
};
export default LightboxImage;